import { render, staticRenderFns } from "./LeftBoxElement.vue?vue&type=template&id=e9d89210"
import script from "./LeftBoxElement.vue?vue&type=script&lang=ts"
export * from "./LeftBoxElement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports